<style lang="less" scoped>
.box-card{margin: 20px;width: 550px;}
/deep/.el-form {width: 500px;}
/deep/.el-input{width: 400px;}
.box{display: flex; flex-wrap:wrap}
</style>

<template>
  <div class="box">
    <div class="box-card" v-for="(each, index) in selectList" :key="index">
      <div class="first">
        <el-form ref="form" class="formBox">
          <el-form-item label="当前列名">
            <el-input v-model="each.name"  :placeholder="each.name" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="上级分类">
            <el-select v-model="each.parentdispc" placeholder="上级分类" clearable>
              <el-option v-for="(item, index) in each.tableData" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称">
            <el-input v-model="each.dispc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onSubmit(each)">添加</el-button>
            <el-button @click="onRemove(each)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:
  {
    selectList: {type: Array} //下拉列分类
  },
  data()
  {
    return {
      tableData: []
    }
  },
  methods:
  {
    //添加下拉值
    onSubmit(each)
    {
      this.$emit('addSelect', each)
    },
    //取消,清空数据
    onRemove(each)
    {
      each.parentdispc = ''
      each.dispc = ''
      this.$emit('onRemove')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/ComboBox.vue